import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { MsalBroadcastService, MsalInterceptor, MsalModule, MsalService } from '@azure/msal-angular';
import { authInitializerProvider } from './providers/auth-initializer.provider';
import { authServiceProvider } from './providers/auth-service.provider';
import { authGuardConfigProvider } from './providers/msal-guard-config.provider';
import { msalInstanceProvider } from './providers/msal-instance.provider';
import { msalInterceptorConfigProvider } from './providers/msal-interceptor-config.provider';
import { AzureADAuthService } from './services/aad-auth.service';
import { AzureB2CAuthService } from './services/b2c-auth.service';
import { BasicAuthService } from './services/basic-auth.service';

export function provideAuth(): EnvironmentProviders {
  return makeEnvironmentProviders([
    importProvidersFrom(MsalModule),
    MsalBroadcastService,
    MsalService,
    MsalInterceptor,
    BasicAuthService,
    AzureADAuthService,
    AzureB2CAuthService,
    authGuardConfigProvider,
    msalInterceptorConfigProvider,
    msalInstanceProvider,
    authServiceProvider,
    authInitializerProvider,
  ]);
}
